<template>
  <div class="grid grid-cols-12 gap-4">

    <div class="col-span-8">
      <RouterView/>
    </div>

    <div class="col-span-4">
      <slot/>
    </div>

  </div>
</template>

<script setup lang="ts">
</script>